import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.scss';
import classNames from 'classnames';

/**
 * Primary UI component for user interaction
 */
export const Button = ({
    children,
    size,
    variant,
    active,
    rounded,
    disabled,
    className,
    hasIcon,
    inGroup,
    ...props
}) => {
    return (<button
            className={classNames(
                styles.btn,
                variant && styles[`variant-${variant}`],
                size && size !== 'md' && styles[`size-${size}`],
                active && styles.active,
                rounded && styles.btn_rounded,
                disabled && styles.disabled,
                className,
                hasIcon && styles.btn_icon,
                inGroup && styles.btn_group,
                )}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>);
};

Button.defaultProps = {
    size:'md',
    active:false,
    rounded:false,
    disabled:false,
    className:'',
    hasIcon:false,
    inGroup:false,
}

Button.propTypes = {
    /**
     * Variants available
     */
    variant: PropTypes.oneOf(['no-style', 'primary', 'primary-dark', 'secondary', 'info', 'success', 'warning', 'error', 'outline-primary', 'outline-secondary', 'outline-info']).isRequired,
    /**
     * How large should the button be?
     */
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    /**
     * Button contents
     */
    children: PropTypes.node.isRequired,
    /**
     * Optional click handler
     */
    onClick: PropTypes.func,
    /**
     * Extra classes it might need
     */
    className: PropTypes.string,
    /**
     * Contains an icon as a children
     */
    hasIcon: PropTypes.bool,
    /**
     * Should be rounded
     */
    rounded: PropTypes.bool,
    /**
     * Is the button in a group
     */
    inGroup: PropTypes.bool,
    /**
     * Condition to resolve if button has active state or not
     */
    active: PropTypes.bool,
    /**
     * Condition to resolve if button has disabled state or not
     */
    disabled: PropTypes.bool,
};
